import hasActiveUploads from './has-active-uploads';
import { isContentStateEmpty } from './content-state-utils';

export default {
  form: 'comment',
  fields: ['content', 'ownerId'],
  validate: ({ content }) => {
    if (isContentStateEmpty(content)) {
      return { content: 'empty' };
    }

    if (content && hasActiveUploads(content)) {
      return { image: 'loading' };
    }
  },
};
